import { render } from "./ContentDisplay.vue?vue&type=template&id=71ef2a50&scoped=true"
import script from "./ContentDisplay.vue?vue&type=script&lang=ts"
export * from "./ContentDisplay.vue?vue&type=script&lang=ts"

import "./ContentDisplay.vue?vue&type=style&index=0&id=71ef2a50&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71ef2a50"

export default script